import {SmartSearchFilterValues} from "../enums";
import {rootActions} from "../DAL/store";
import {searchServer} from "../DAL/data-service";
import {SiteSearchVM} from "../interfaces";
import {
    mediaBaseDomain, queryStringSafeChars
} from "../constants";
import EditIcon from "../../../../ui/svg/common/edit";

import {DownloadSVGIcon, NoImageSVGIcon, QuestionMarkSVGIcon, VideoSVGIcon} from "../components/icons-svg";
import { sendGAEvent } from '../../../../domain/marketing/gtm-provider';

/**
 * On page load - init url patams, query search results ( if searchtext param is not null)
 */
export const OnPageLoad = async (dispatch: any,setIsLoading :any) => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let storeObject = {} as any;
    if(urlParams.has("searchtext")){
        storeObject.SearchQuery = urlParams.get("searchtext");

    }
    if(urlParams.has("smartsearchfilter")){
        let paramValue = Number(urlParams.get("smartsearchfilter"));
        let filterValue = 0;
        switch(paramValue){

            case SmartSearchFilterValues.Products: {
                filterValue = SmartSearchFilterValues.Products;
                break;
            }
            case SmartSearchFilterValues.DownloadSupportAccount: {
                filterValue = SmartSearchFilterValues.DownloadSupportAccount;
                break;
            }
            case SmartSearchFilterValues.VideosBlogposts: {
                filterValue = SmartSearchFilterValues.VideosBlogposts;
                break;
            }
            default: {
                filterValue = SmartSearchFilterValues.AllPages;
            }
        }
        storeObject.CurrentMainTab = filterValue;


    }

    if(storeObject.SearchQuery){
        let currentMainTab = storeObject.CurrentMainTab? storeObject.CurrentMainTab : 0;
        let pageNumber = 0;
        if(urlParams.has("page")){
             pageNumber = Number(urlParams.get("page")) > 0 ? (Number(urlParams.get("page")) - 1)  : 0;
        }
        await SearchAction(storeObject.SearchQuery,currentMainTab,pageNumber,dispatch, true,setIsLoading);
        // jump to top
        window.scrollTo(0, 0);
    }else{
        dispatch(
            rootActions.main(storeObject)
        );
    }

}

/**
 * Main Search Action
 *
 * Query search items by : SearchQuery, CurrentMainTab (smartsearchfilter param), currentPage (search pagination )
 *
 * Sets page's title & URL params by query params
 *
 */
export const SearchAction = async (SearchQuery:string ,CurrentMainTab:number,currentPage:number,dispatch:any , isOnLoad : boolean, setIsLoading: any) => {
    setIsLoading(true);
    let _safeSearchQuery = SearchQuery.replace(queryStringSafeChars,'');
    const response = await searchServer(_safeSearchQuery, CurrentMainTab,currentPage);
    if(!response || response.statusCode !== 200 || !response.data.isValid || !response.data.relatedData) {
        setIsLoading(false);
        return;
    }
    setIsLoading(false);
    const data = response.data.relatedData as SiteSearchVM;

    // q: {query} | rc: {number of results}
    // q: api | rc: 4
    sendGAEvent('KenticoSearchQuery', `q: ${ _safeSearchQuery.toLowerCase() } | rc: ${ data.totalNumberOfResults }`);

    const totalPagesNumber = Math.ceil(data.totalNumberOfResults / data.numberOfItemsPerPage);
    const currentPageNumber =  totalPagesNumber <= currentPage + 1  ? totalPagesNumber -1  : currentPage;

    dispatch(
        rootActions.main({
            SearchQuery:_safeSearchQuery,
            CurrentMainTab:CurrentMainTab,
            SearchResults:data.searchResults,
            CurrentPageNumber:currentPageNumber,
            NumberOfItemsPerPage:data.numberOfItemsPerPage,
            TotalNumberOfResults: data.totalNumberOfResults,
            ShowNoResults:data.searchResults.length === 0
        })
    );
    let searchParamsUrl = "?";

    searchParamsUrl += "searchtext=" + _safeSearchQuery + "&";
    searchParamsUrl += "smartsearchfilter=" + CurrentMainTab + "&";
    searchParamsUrl += "page=" + (currentPageNumber + 1);

    let urlWithParams = document.location.pathname + searchParamsUrl;

    //push state only on new search ( not on page load ).
    if(!isOnLoad){
        window.history.pushState({reloadPage : true}, '', urlWithParams);
    }else{
        window.history.replaceState({}, '', urlWithParams);

    }

    document.title = _safeSearchQuery  +" | Search | Waves";

}

/**
 * Get item's image path for search result view
 * Logic from : \CMS\3appcode\Macro\Macros.cs
 */
export const GetSearchItemImgPath = (imgPath :string) => {

    if(imgPath.includes("/products/")){

        return  mediaBaseDomain + imgPath;

    }
    return "";

}
/**
 * Get item's svg for non product search result
 * Logic from : \CMS\3appcode\Macro\Macros.cs
 */
export const GetSearchItemSvg = (imgPath :string,pagePath:string) => {

    let svgElement = <NoImageSVGIcon  />;

    if(imgPath.includes("/videos/")){

        svgElement = <VideoSVGIcon />;

    }else if(imgPath.includes("/blog/") || imgPath.includes("/artists/")){

        svgElement = <EditIcon width={"100%"} height={"100%"} color="#4A4A4A"/>;

    }else if(pagePath.includes("/support/")){

        svgElement = <QuestionMarkSVGIcon />;

    }else if(pagePath.includes("/downloads/")){

        svgElement = <DownloadSVGIcon />;

    }else{

        svgElement = <NoImageSVGIcon  />;
    }
    return svgElement;

}
/**
 * Get item's type for search result view
 * Logic from : \CMS\3appcode\Macro\Macros.cs
 */
export const GetSearchItemType = (imgPath :string,pagePath:string ) => {

    let itemType = "";

    if(imgPath.includes("/products/")){

        itemType = "Product";

    }else if(imgPath.includes("/videos/")){
        itemType = "Video";

    }else if(imgPath.includes("/blog/")){

        itemType = "Blog";

    }else if(pagePath.includes("/artists/")){

        itemType = "Artist";
    }else if(pagePath.includes("/support/")){

        itemType = "Support";
    }else if(pagePath.includes("/downloads/")){

        itemType = "Download";

    }
    return itemType;

}